import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'rcp-nav-list-header',
  template: `
    <span class="nav-list-header">
      <ng-content />
      {{ label() }}
      <ng-content select="[trailing-detail]" />
    </span>
  `,
  styles: `
    .nav-list-header {
      display: flex;
      gap: var(--item-spacing-between-md);

      font-size: var(--font-size-header-2);
      font-weight: var(--font-weight-bold);
      color: var(--col-text-headers);
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NavListHeaderComponent {
  label = input<string>('');
}
